
import ssoImg1 from "./../../../../assets/images/ErirbRegistration.png"; // Adjust the path as necessary

function SeaWatchReponseErirbRegistrationTab() {


  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SEA WATCH & RESPONSE
        <span className="text-orange-ef3e33 font-400"> ERIRB REGISTRATION </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          
          <p className="mb-3 text-primary-color">EPIRB (Emergency Position-Indicating Radio Beacon), are tracking transmitters which aid in the detection and location of vessels and people in  distress. Strictly, they are radiobeacons that interface with worldwide offered service of Cospas-Sarsat, the international satellite system  for search and rescue (SAR).</p>

          <p className="mb-3 text-primary-color">A distress signal is sent when the EPIRB is manually activated, or it can be automatically activated upon immersion,.The signals are monitored  worldwide and the location of the distress is detected by  non-geostationary satellites</p>

          <p className="mb-3 text-primary-color">The basic purpose of a distress radiobeacon is to help rescuers find survivors within the so-called "golden day"[2] (the first 24 hours following a traumatic event) during which the majority of survivors can usually be saved.</p>

          <p className="mb-3 text-primary-color">The owner and operator of every vessel of South African Nationality must  ensure that every EPIRB carried on the vessel must be registered with  the MRCC and that the EPIRB particulars are correct.</p>

        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
        
      </div>
    </>
  );
}

export default SeaWatchReponseErirbRegistrationTab;